import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { StructureOrganizative, ToastrService, AuthService, CacheService } from '@mapfre-tech/amap3';
import { Observable, throwError } from "rxjs";
import { map, mergeMap, catchError } from "rxjs/operators";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Injectable({
   providedIn: "root"
})
export class TimeAllocationService {

   className = 'TimeAllocationService';

   constructor(private http: HttpClient, private translateService: TranslateService, private toastService: ToastrService, private authService: AuthService, private cacheService: CacheService) { }

   getAll(cache = true, cacheKey = "allAllocationTimeStateNodes"): Observable<any[]> {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get<any[]>(environment.base_URL + "/types-state-nodes/").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }
   getImpDateByDate(userId, startDate, endDate): Observable<any[]> {
      const params: any = {};
      if (startDate) {
         params.startDate = startDate;
      }
      if (endDate) {
         params.finishDate = endDate;
      }
      return this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}`, { params }).pipe(map(result => {

         _.forEach(result, item => {
            item.txtTypeConceptImputation = item.imputationConcept;
            item.txtTypeSubconceptImputation = item.imputationSubConcept;
         });

         const final: any[] = [];

         let groupBy = _.chain(result)
            .groupBy(x => x.typeConceptImputationId)
            .map((value, key) => value)
            .value();

         const tempArray: any[] = [];
         _.forEach(groupBy, (group: any) => {
            const groupTemp = _.chain(group)
               .groupBy(x => x.txtComment)
               .map((value, key) => value)
               .value();               
               tempArray.push(groupTemp);
               
         });

         groupBy = _.flatten(tempArray);

         _.forEach(groupBy, (group: any) => {
            let groupTemp = _.chain(group)
               .groupBy(x => x.jobId ? x.jobId : x.paiId)
               .map((value, key) => value)
               .value();
            const array: any[] = [];
            _.forEach(groupTemp, groupItemTemp => {
               const groupByDays = _.chain(groupItemTemp)
                  .groupBy(x => x.dateImputation)
                  .map((value, key) => value)
                  .value();

               for (let index = 0; index < groupByDays[0].length; index++) {
                  const arrayTemp: any[] = [];
                  _.forEach(groupByDays, (days, i) => {
                     if (_.get(days, index)) {
                        arrayTemp.push(_.get(days, index));
                     }
                  })
                  array.push(arrayTemp);
               }
            });

            groupTemp = array;

            _.forEach(groupTemp, groupItemTemp => {
               const fatherTemp = _.cloneDeep(groupItemTemp[0]);
               _.forEach(groupItemTemp, it => it.init = true);
               fatherTemp.imputationTime = groupItemTemp;

               final.push(fatherTemp);
            })

         })


         return _.orderBy(final, 'idImputationPk', 'asc');
      }));
   }

   getImpDaysByDate(userId, filtersBack) {

      let params: any = {};
      if (filtersBack) {
         params = filtersBack;
      }

      return this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}`, { params });
   }

   newImpDate(allocation) {
      return this.http.post(environment.base_URL + "/imputation-times", allocation);
   }

   getSummary(userId, cache = true, cacheKey = "timeSummary"): Observable<any[]> {
      cacheKey = cacheKey+"_"+userId.toString()
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}/info`).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
      
   }

   getActivitesBySO(structureId, cache = true, cacheKey = "activitiesBySO"): Observable<any[]> {
      cacheKey = cacheKey+"_"+structureId.toString()
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         const observable = this.http.get<any[]>(environment.base_URL + `/imputation-times/activities/os/${structureId}`).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   /**
 * Export jobs
 * @param key 
 * @param params 
 */
   exportImputation(key, params) {

      // Set key file in parameters
      _.set(params, "key", key + '/data.json');

      if (!params.finishDate) {
         params.finishDate = moment(new Date(new Date().getFullYear(), 11, 31)).format('YYYY-MM-DD');
      }

      if (!params.startDate) {
         params.startDate = moment(new Date(new Date().getFullYear(), 0, 1)).format('YYYY-MM-DD')
      }

      // Call aws gateway to generate pre signed url
      return this.http.get<any[]>(environment.base_URL + "/exported-url", { params })
         .pipe(mergeMap((res: any) => {

            // Remove key paramenter and add url parameter
            _.unset(params, "key")
            _.set(params, "url", res)

            // Call Mapgre Gateway to generate excel with exoprted jobs
            return this.http.get<any[]>(environment.base_URL + "/exported-imputations", { params })
               .pipe(mergeMap((res: any) => {

                  // Remove url paramenter and add key parameter
                  const paramsExcel = {}
                  _.set(paramsExcel, "keydata", key + '/data.json');
                  _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                  return this.http.get<any[]>(environment.base_URL + "/create-excel", { params: paramsExcel })
                     .pipe(mergeMap((res3: any) => {

                        // Remove url paramenter and add key parameter
                        const paramsDownload = {}
                        _.set(paramsDownload, "onlyDownload", true)

                        const body = {
                           key: key + '/export.xlsx'
                        }

                        // Download excel
                        return this.http.post(environment.base_URL + `/download`, body, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {

                              // Download file
                              const options = {
                                 responseType: "blob" as 'json'
                              }

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              // Delete file when downloaded
                              this.delete(key).subscribe();
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))
                     }))
               }))

         }), map(res => {
            return res;
         }), catchError(err => {
            this.toastService.add({
               severity: "error",
               summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
               detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
            });
            return throwError(err);
         }))


   }


   delete(key): any {
      const params = {
         key
      }
      return this.http.post(environment.base_URL + "/delete", { params }).pipe(catchError(err => {
         this.toastService.add({
            severity: "error",
            summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
            detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
         });
         return throwError(err);
      }));
   }

}
